const DEFAULT_TEST_ID = '1'

export default DEFAULT_TEST_ID
